import { createSlice } from "@reduxjs/toolkit";

const persistedAgent = localStorage.getItem("selectedAgent") || "";

export interface UiRenderType {
  tableDataRerender: boolean;
  globalLoading: boolean;
}

const initialState: UiRenderType = {
  tableDataRerender: false,
  globalLoading: false,
};

const globalRenderSlice = createSlice({
  name: "globalRenderSlice",
  initialState,
  reducers: {
    setTableDataRerender: (state, action) => {
      state.tableDataRerender = action.payload;
    },
    setGlobalLoading: (state, action) => {
      state.globalLoading = action.payload;
    },
  },
});

export const {
  setGlobalLoading,

  setTableDataRerender,
} = globalRenderSlice.actions;

export default globalRenderSlice.reducer;
